module.exports = __webpack_public_path__ + "img/movilidad-icon.3f5bcaf2.svg";